import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import NFormatterFun from './Formatter';
import linePalette from 'assets/js/palette';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface LineChartProps {
  chartData: any;
}

export const LineChart = ({ chartData }: LineChartProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    const optionsData = {
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0,
        },
      },
      scales: {
        y: {
          grid: {
            display: true,
          },
        },
        x: {
          grid: {
            display: true,
          },
        },
      },
      responsive: true,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      plugins: {
        legend: {
          position: 'bottom',
          display: chartData?.length > 1,
        },
      },
    };

    setOptions(optionsData);
  }, [chartData?.length]);

  const manuplateData = (chartData: any) => {
    if (chartData) {
      const tempdata: any = {
        labels: [],
        datasets: [],
      };

      chartData.forEach((d: any, i: any) => {
        const colors = linePalette('cb-Custom1', chartData.length).map(function (hex: any) {
          return '#' + hex;
        });
        const tempObj: any = {
          label: '',
          borderColor: d.colorPaletteCode ? d.colorPaletteCode : colors[i],
          backgroundColor: d.colorPaletteCode ? d.colorPaletteCode : colors[i],
          fill: false,
        };

        const tempdataArr: any = [];
        const tempdatalabel: any = [];
        let tempVal: any = '';
        tempObj.label = d.headerName;
        d.plots.forEach((d1: any) => {
          tempVal = NFormatterFun(d1.value, d1.symbol, 'Unit');
          tempVal = typeof tempVal == 'string' ? parseFloat(tempVal.replace(/,/g, '')) : tempVal;
          tempdataArr.push(d1.value && d1.value.toFixed(2));
          tempdatalabel.push(d1.name);
        });
        tempObj.data = tempdataArr;
        tempdata.labels = tempdatalabel;
        tempdata.datasets.push(tempObj);
      });
      return tempdata;
    }
  };
  const data = manuplateData(chartData);

  if (data) {
    return (
      <div className="custom-chart-size-2">
        <Line style={{ fill: 'none' }} data={data} options={options} width="400" height="275" />
      </div>
    );
  }

  return (
    <>
      <div className="">
        <img className="empty-state-3" src="/icons/Empty_icon.svg" alt="empty visual" />
      </div>
      <div className="">
        <label className="label-style-4 mt-3">{t('EMPTY_STATE.NO_DATA_FOUND')}</label>
      </div>
      <div className="w-50">
        <label className="label-style-5 mt-3">
          Please add the data to view corresponding visualisation here
        </label>
      </div>
    </>
  );
};
